module.exports = __webpack_public_path__ + "static/detecht-casebg@2x-min-837f935d07f994c85f5dcda987b3063c.jpg";